import { render, staticRenderFns } from "./DriverPermissions.vue?vue&type=template&id=b4b4b198&"
import script from "./DriverPermissions.vue?vue&type=script&lang=js&"
export * from "./DriverPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports